export function normalizeRearrangeResponse(payload) {
  if (Array.isArray(payload)) {
    return {
      eventId: null,
      classId: null,
      currentSlot: null,
      matches: payload,
    };
  }

  return {
    eventId: payload?.eventId ?? null,
    classId: payload?.classId ?? null,
    currentSlot: payload?.currentSlot ?? null,
    matches: Array.isArray(payload?.matches) ? payload.matches : [],
  };
}

export function formatRearrangeSlot(slot) {
  if (!slot?.date || !slot?.hour || !slot?.to) {
    return "";
  }

  const [year, month, day] = slot.date.split("-").map(Number);
  const parsedDate = new Date(year, month - 1, day);
  const formattedDate = Number.isNaN(parsedDate.getTime())
    ? slot.date
    : parsedDate.toLocaleDateString("pt-BR");

  return `${formattedDate} das ${slot.hour} às ${slot.to}`;
}
